export interface StrategyEvent {
  id?: string
  timestamp: string
  level: LEVELS
  type: string
  message: string
}

export enum LEVELS {
  INFO = 'INFO',
  WARN = 'WARN',
  CRITICAL = 'CRITICAL'
}
